module.exports = __webpack_public_path__ + "img/menu-property.2c137fa.svg";